// extracted by css-extract-rspack-plugin
export default {"BillBrandLogo-logo":"sputnik__BillBrandLogo-logo__geJMN","billBrandLogoLogo":"sputnik__BillBrandLogo-logo__geJMN"};